import React, { createContext, useContext, useState } from 'react';
import { LiveSession } from '../hooks/useLiveSession';

interface SessionContextValue {
  sessionId: string;
  setSessionId: (id: string) => void;
  liveSession: LiveSession | null;
  setLiveSession: (session: LiveSession | null) => void;
}

export const SessionContext = createContext<SessionContextValue | undefined>(undefined);

interface SessionProviderProps {
  initialSessionId?: string;
  children: React.ReactNode;
}

export const SessionProvider: React.FC<SessionProviderProps> = ({
  initialSessionId = '6307',
  children,
}) => {
  const [sessionId, setSessionId] = useState<string>(initialSessionId!);
  const [liveSession, setLiveSession] = useState<LiveSession | null>(null);
  return (
    <SessionContext.Provider value={{ sessionId, setSessionId, liveSession, setLiveSession }}>
      {children}
    </SessionContext.Provider>
  );
};

export function useSession() {
  const ctx = useContext(SessionContext);
  if (!ctx) throw new Error('useSession debe usarse dentro de <SessionProvider>');
  return ctx;
}
